/**
 * Code-name formats per hierarchy level. They mirror the backend domain
 * classes (`IcdChapter` / `IcdBlock` / `IcdCode`, `OpsChapter` / `OpsBlock` /
 * `OpsCode`), which reject a name in the wrong format. The three levels of a
 * coding system are disjoint, so a name alone tells which level it is — see
 * `AysCode.hierarchyElementTypeOf`.
 */

/** ICD chapter: a roman numeral, `I` … `XXII`. */
export const ICD_CHAPTER_PATTERN = /^X?(XI{0,2}|IX|IV|V?I{0,3})$/;

/** ICD block (Gruppe): `A00-A09`. */
export const ICD_BLOCK_PATTERN = /^[A-Z][0-9][0-9]-[A-Z][0-9][0-9]$/;

/** ICD leaf code: `A00`, `A00.1`, `C50.12+`, or the unknown code `AAA`. */
export const ICD_SPECIFIC_PATTERN =
  /^([A-Z][0-9][0-9]((\.[0-9]{1,2}[!#*+]?)|[!#*+]?)?|AAA)$/;

/** OPS chapter: one digit (`1`, `3`, `5`, `6`, `8`, `9`). */
export const OPS_CHAPTER_PATTERN = /^[135689]$/;

/** OPS block (Gruppe): `1-20...1-33`. */
export const OPS_BLOCK_PATTERN = /^[0-9]-[0-9]{2}\.\.\.[0-9]-[0-9]{2}$/;

/** OPS leaf code: `5-82`, `5-820`, `5-820.0`, or the unknown code `a-aaa`. */
export const OPS_SPECIFIC_PATTERN =
  /^([0-9]-[0-9][0-9]([a-z0-9](\.[a-z0-9]{1,2})?)?|a-aaa)$/;
